module.exports = __webpack_public_path__ + "img/monitorbox24.afaa7980.jpg";